import { useState } from 'react';

import Filter from '../../models/Filter';

export const useGetFilter = () => {
  const [data, setData] = useState(new Filter());

  const updateFilter = (newFilter: Filter) => {
    setData(newFilter);
  };

  return { data, updateFilter };
};
